import { LOADER } from '../constants'

export function enableOrDisableLoading(isLoading) {
	return {
		type: LOADER.ENABLE_OR_DISABLE_LOADING,
		isLoading,
	}
}
